<div class="container-fluid" style="background-color: #1d2229">
    <div class="row">
        <div class="col-sm-2">
            <div class="content">
                <div class="container-lg text-center" style="background-color: #1d2229">
                    <div class="row">
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 11]" 
                                [ngStyle]="{ color: statusDocks(11) }">
                                Doca 5
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 8]"
                                [ngStyle]="{ color: statusDocks(8) }">
                                Doca 6
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 9]"
                                [ngStyle]="{ color: statusDocks(9) }">
                                Doca 7
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 10]"
                                [ngStyle]="{ color: statusDocks(10) }">
                                Doca 8
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 7]"
                                [ngStyle]="{ color: statusDocks(7) }">
                                Doca 9
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 4]"
                                [ngStyle]="{ color: statusDocks(4) }">
                                Doca 10
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 3]"
                                [ngStyle]="{ color: statusDocks(3) }">
                                Doca 11
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 2]"
                                [ngStyle]="{ color: statusDocks(2) }">
                                Doca 12
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-sm-10">
            <router-outlet></router-outlet>
        </div>

    </div>
</div>